<div class="profile-container">
  <div class="">
    <div class="profile-content">
      <div class="personal-details">

        <div class="header-block">
          <div class="header-title">
            <p>Privilege List</p>
          </div>
          <div class="add-block d-flex align-items-center">
            <button (click)="addPrivilege()">Submit</button>
          </div>
        </div>

        <table class="table table-striped">
          <thead>
            <tr>
              <th style="width: 10%;">Seq No</th>
              <th style="width: 35%;">Group Name</th>
              <th style="width: 35%;">Screen List</th>
              <th style="width: 20%;text-align: center;padding: 0;" class="">Action</th>
            </tr>
          </thead>
        </table>
        <div>
          <div class="data-view" *ngFor="let privilege of privilegesData;let i = index">

            <p style="width: 10%;">{{privilege.seqNo}}</p>
            <p style="width: 35%;">{{privilege.groupName}}</p>
            <p style="width: 35%;padding-left: 25px;">{{privilege.screenPrivilegeList?.length || 0}}</p>
            <p class="action-buttons" style="width: 20%;padding-left: 25px;">
              <i class="bi bi-eye-fill" data-toggle="modal" data-target="#exampleModalView"
                (click)="viewPrivilege(privilege)"></i>
              <i class="bi bi-pencil-square mx-2" data-toggle="modal" data-target="#exampleModalEdit"
                (click)="editPrivilege(privilege)"></i>
              <i class="bi bi-check-circle-fill text-success" *ngIf="privilege.isSubmitted" title="Submitted"></i>
              <i class="bi bi-x-circle-fill text-danger" *ngIf="privilege.isError" title="Error"></i>
            </p>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="exampleModalView" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Privilege
          <span data-dismiss="modal">
            <svg data-dismiss="modal" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
              class="bi bi-x-lg" viewBox="0 0 16 16">
              <path
                d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z" />
            </svg>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <div *ngFor="let privilege of singlePrivilege; let i = index">
          <div class="row">
            <div class="col-md-6 col-lg-6">
              <div class="form-group">
                <label>Group Seq No</label>
                <input value="{{privilege.seqNo}}" type="text" class="form-control" readonly>
              </div>
            </div>
            <div class="col-md-6 col-lg-6">
              <div class="form-group">
                <label>Group Name</label>
                <input value="{{privilege.groupName}}" type="text" class="form-control" readonly>
              </div>
            </div>
            <div class="col-md-12 col-lg-12">
              <h5 class="sub-menu-heading">Sub Menus ( {{privilege.screenPrivilegeList?.length || 0}} )</h5>
              <div *ngFor="let screenPrivilegeList of privilege.screenPrivilegeList; let j = index">
                <div class="screenList">
                  <div class="sub-menu-block">
                    <div>
                      <label for="">sub menu name :</label>
                      <p> {{screenPrivilegeList.description}}</p>
                    </div>
                    <div>
                      <label for="">router link :</label>
                      <p> {{screenPrivilegeList.name}}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" id="updateButton" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="exampleModalEdit" tabindex="-1" aria-labelledby="exampleModalLabelEdit" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content border-0 shadow-lg" style="border-radius: 8px; overflow: hidden;">
      <div class="modal-header border-0" style="background-color: #252d40; color: white;">
        <h5 class="modal-title" id="exampleModalLabelEdit" style="font-weight: 600;">Edit Privilege</h5>
        <span data-dismiss="modal" style="cursor: pointer; color: white; opacity: 0.8;" onmouseover="this.style.opacity=1" onmouseout="this.style.opacity=0.8">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
              <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z" />
            </svg>
        </span>
      </div>
      <div class="modal-body p-4" style="background-color: #f8f9fa;">
        <div *ngFor="let privilege of singlePrivilege; let i = index">
          
          <div class="row mb-4">
            <div class="col-md-6">
              <div class="form-group mb-0">
                <label class="text-secondary mb-2" style="font-size: 14px; font-weight: 600;">Group Seq No</label>
                <input [(ngModel)]="privilege.seqNo" [ngModelOptions]="{standalone: true}" type="text" class="form-control shadow-sm border-0" style="height: 42px;">
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group mb-0">
                <label class="text-secondary mb-2" style="font-size: 14px; font-weight: 600;">Group Name</label>
                <input [(ngModel)]="privilege.groupName" [ngModelOptions]="{standalone: true}" type="text" class="form-control shadow-sm border-0" style="height: 42px;">
              </div>
            </div>
          </div>

          <div class="d-flex justify-content-between align-items-center pb-2 mb-3" style="border-bottom: 2px solid #e9ecef;">
            <h5 class="mb-0" style="color: #252d40; font-weight: 600;">
              Sub Menus 
              <span class="badge" style="background-color: #e2e8f0; color: #475569; margin-left: 8px;">{{privilege.screenPrivilegeList?.length || 0}}</span>
            </h5>
          </div>

          <div class="sub-menus-container">
            <div *ngFor="let screenPrivilegeList of privilege.screenPrivilegeList; let j = index" class="card mb-3 border-0 shadow-sm" style="border-radius: 8px; transition: transform 0.2s;">
              <div class="card-body position-relative p-3">
                
                <div class="sub-menu-inline-row" style="overflow-x: auto; padding-bottom: 2px;">
                  <div class="sub-menu-inline-item">
                    <label>Sub Menu Name</label>
                    <input type="text" [(ngModel)]="screenPrivilegeList.description" [ngModelOptions]="{standalone: true}" placeholder="Enter name">
                  </div>
                  <div class="sub-menu-inline-item">
                    <label>Router Link</label>
                    <input type="text" [(ngModel)]="screenPrivilegeList.name" [ngModelOptions]="{standalone: true}" placeholder="Enter link">
                  </div>
                  <div class="sub-menu-inline-actions">
                    <span (click)="removeSubMenu(j)" class="text-danger" title="Remove">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16">
                        <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
                        <path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>
                      </svg>
                    </span>
                    <span (click)="addSubMenu(j)" class="text-success" title="Add Below">
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" class="bi bi-plus-circle" viewBox="0 0 16 16">
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                      </svg>
                    </span>
                  </div>
                </div>

              </div>
            </div>
            
            <div *ngIf="!privilege.screenPrivilegeList || privilege.screenPrivilegeList.length === 0" class="text-center py-5 text-muted shadow-sm" style="background-color: white; border-radius: 8px; border: 1px dashed #ced4da;">
              <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" class="bi bi-inbox mb-2" viewBox="0 0 16 16">
                <path d="M4.98 4a.5.5 0 0 0-.39.188L1.54 8H6a.5.5 0 0 1 .5.5 1.5 1.5 0 1 0 3 0A.5.5 0 0 1 10 8h4.46l-3.05-3.812A.5.5 0 0 0 11.02 4H4.98zm-1.17-.437A1.5 1.5 0 0 1 4.98 3h6.04a1.5 1.5 0 0 1 1.17.563l3.7 4.625a.5.5 0 0 1 .106.374l-.39 3.124A1.5 1.5 0 0 1 14.117 13H1.883a1.5 1.5 0 0 1-1.489-1.314l-.39-3.124a.5.5 0 0 1 .106-.374l3.7-4.625zM.125 8.125a.5.5 0 0 1 .5-.5H6a.5.5 0 0 1 .5.5 1.5 1.5 0 0 0 3 0 .5.5 0 0 1 .5-.5h5.375a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-15a.5.5 0 0 1-.5-.5v-.5z"/>
              </svg>
              <div style="font-weight: 500;">No sub-menus added</div>
              <div style="font-size: 13px;">Click the button above to add one</div>
            </div>
          </div>

        </div>
      </div>
      <div class="modal-footer border-0 pt-0 pb-4 px-4">
        <button type="button" class="btn btn-light shadow-sm px-4" data-dismiss="modal" style="font-weight: 500; background-color: #f1f5f9; border: none; color: #475569;">Close</button>
        <button type="button" class="btn btn-primary shadow-sm px-4" data-dismiss="modal" style="font-weight: 500; background-color: #0d6efd; border: none;">Save Changes</button>
      </div>
    </div>
  </div>
</div>